<template>
	<div>
		<template v-if="type == 'mobile'">
			<div class="py-4 border-semi-grey radius-12">
    		<div class="px-3 text-center">
	    		<p class="heading-6 mb-1 text-semi-dark">{{data.tagline}}</p>
	    		<p class="body-2-2-1 mb-3">{{data.sub_tagline}}</p>
	    	</div>

    		<flickity ref="flickity" class="mb-3" :options="$freeScrollSliderOption">
		      <div class="carousel-cell w-75 mr-3" :class="{'pl-3':index == 0, 'pr-3':index == data.product.length - 1}" v-for="(things_to_do_item,index) in data.product">
		        <div class="w-100 border-semi-grey radius-12" style="height:312px !important;">
		        	<div class="w-100" style="height:180px;">
    						<img :src="things_to_do_item.cover_image_url" class="img-fit radius-12-t">
		        	</div>
		        	<div class="w-100 p-3">
		        		<div class="row no-gutters">
		        			<div class="col-1 align-self-center">
		        				<img src="../../../assets/img/hotel/marker.png" width="14" style="margin-top:-5px !important;">
		        			</div>
		        			<div class="col-11 align-self-center">
		        				<p class="mb-0 body-2 text-truncate">{{things_to_do_item.merchant_address}}</p>
		        			</div>
		        		</div>
        				<p class="mb-0 body-1-2">{{things_to_do_item.name}}</p>
        				<div class="w-100">
        					<span class="body-1-2 d-inline-block aling-middle text-orange mr-1">{{$formatCurrency(things_to_do_item.price_sell)}}</span><span class="body-2-2-1 d-inline-block aling-middle" v-if="things_to_do_item.unit != null">/{{things_to_do_item.unit.unit}}</span>
        				</div>
		        	</div>
		        </div>
		      </div>
		    </flickity>

		    <div class="mb-3 px-3">
			  	<div class="mb-3">
				  	<p class="body-1-2 mb-0">{{data.name}} {{$t('hotel.concierge.fitur.spa.categories')}}</p>
		    	</div>
		    	<div class="w-100">
		    		<flickity ref="flickity2" :options="$freeScrollSliderOption">
		    			<div class="carousel-cell product-small-wrapper mr-3" :id="category.id" v-for="category in data.product_category">
		    				<div class="product-small mb-2">
		    					<img :src="category.image_url" class="img-fit radius-6" />
		    				</div>
		    				<p class="body-2-1 mb-0 text-truncate">{{category.name}}</p>
		    			</div>
		    		</flickity>
		    	</div>
			  </div>

		    <div class="py-2 px-3 border-semi-grey radius-6 mr-3 ml-auto d-table" @click="goToDetail">
		    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.spa.explore-more')}}</p>
      		<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12 text-green"></i>
		    </div>
    	</div>
		</template>
		<template v-if="type == 'desktop'">
			<div class="py-4 pl-4 border-semi-grey radius-12">
    		<div class="row mb-3">
    			<div class="col-7 align-self-center">
    				<div class="pr-3 d-inline-block aling-middle">
			    		<p class="sub-heading-1-1 mb-1 text-semi-dark">{{data.tagline}}</p>
			    		<p class="body-2-2-1 mb-0">{{data.sub_tagline}}</p>
			    	</div>
    			</div>
    			<div class="col-5 align-self-center">
    				<div class="py-2 px-3 border-semi-grey radius-6 mr-3 ml-auto d-table cursor-pointer" @click="goToDetail">
				    	<p class="mb-0 text-green body-2 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.spa.explore-more')}}</p>
				    </div>
    			</div>
    		</div>
    		<flickity ref="flickity" class="mb-3" :options="freeScrollSlider">
		      <div class="carousel-cell w-45 mr-3" v-for="things_to_do_item in data.product">
		        <div class="w-100 border-semi-grey radius-12" style="height:312px !important;">
		        	<div class="w-100" style="height:180px;">
    						<img :src="things_to_do_item.cover_image_url" class="img-fit radius-12-t">
		        	</div>
		        	<div class="w-100 p-3">
		        		<div class="row no-gutters">
		        			<div class="col-1 align-self-center">
		        				<img src="../../../assets/img/hotel/marker.png" width="14" style="margin-top:-5px !important;">
		        			</div>
		        			<div class="col-11 align-self-center">
		        				<p class="mb-0 body-2 text-truncate">{{things_to_do_item.merchant_address}}</p>
		        			</div>
		        		</div>
        				<p class="mb-0 body-1-2 text-truncate-2">{{things_to_do_item.name}}</p>
        				<div class="w-100">
        					<span class="body-1-2 d-inline-block aling-middle text-orange mr-1">{{$formatCurrency(things_to_do_item.price_sell)}}</span><span class="body-2-2-1 d-inline-block aling-middle" v-if="things_to_do_item.unit != null">/{{things_to_do_item.unit.unit}}</span>
        				</div>
		        	</div>
		        </div>
		      </div>
		    </flickity>
		    <div class="w-100">
			  	<div class="mb-3 pt-3">
				  	<p class="body-1-2 mb-0">{{data.name}} {{$t('hotel.concierge.fitur.spa.categories')}}</p>
		    	</div>
		    	<div class="w-100">
		    		<flickity ref="flickity2" :options="$freeScrollSliderOption">
		    			<div class="carousel-cell product-big-wrapper mr-3" :id="category.id" v-for="category in data.product_category">
		    				<div class="product-big mb-2">
		    					<img :src="category.image_url" class="img-fit radius-6" />
		    				</div>
		    				<p class="body-2-1 mb-0 text-truncate">{{category.name}}</p>
		    			</div>
		    		</flickity>
		    	</div>
			  </div>
    	</div>
		</template>
	</div>
</template>
<script>
  import Flickity from 'vue-flickity';
  import {mapGetters} from 'vuex'

	export default{
		props: ['type','data'],
		components:{
			Flickity
		},
		data(){
			return{
				freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: false,
          contain: true,
          cellAlign: 'left'
        },
			}
		},
		computed:{
			...mapGetters(['getMerchant'])
		},
		methods:{
			goToDetail(){
				this.$trackHomeClick('MODULE PREVIEW',`Clicked detail ${this.data.code}`)
				this.$router.push(`/${this.getMerchant.code}/concierge/experience`)
			}
		}
	}
</script>
<style>
	.product-small{
		width:100px;
		height:100px;
	}
	.product-small-wrapper{
		width:100px;
	}
	.product-big{
		width:230px;
		height:164px;
	}
	.product-big-wrapper{
		width:230px;
	}
</style>


// WEBPACK FOOTER //
// src/components/hotel/general/ThingsToDoPreview.vue